import { Component, OnInit, OnDestroy } from '@angular/core';
import { IxellAPIService } from 'src/app/tools/api.service';
import { Validationmail } from './validationmail';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Utils } from 'src/app/tools/utils';
import { HeaderService } from '../../tools/header.service';

@Component({
  selector: 'app-renaultmail',
  templateUrl: './renaultmail.component.html',
  styleUrls: ['./renaultmail.component.scss']
})
export class RenaultmailComponent implements OnInit, OnDestroy {

  allRTmailSub:any;
  modifyRtSub:any;
  deleteRtSub:any;
  addRtSub:any;

  allMails : Validationmail[] = [];
  actualMail = "";
  actualName = "";
  actualLocation = "";
  actualCity = "";
  actualLogin = "";
  actualId = 0;

  errorForm:boolean = false;
  
  countries = [
    { name: "France", value: "France" },
    { name: "Belgique", value: "Belgium" },
    { name: "Pays-Bas", value: "Netherlands" },
    { name: "Luxembourg", value: "Luxembourg" },
    { name: "Espagne", value: "Spain" },
    { name: "Portugal", value: "Portugal" },
    { name: "Italie", value: "Italy" },
    { name: "Allemagne", value: "Germany" },
    { name: "Suisse", value: "Switzerland" },
    { name: "Autriche", value: "Austria" },
    { name: "Pologne", value: "Poland" },
    { name: "Lituanie", value: "Lithuania" },
    { name: "Slovenie", value: "Slovenia" },
    { name: "Slovaquie", value: "Poland" },
    { name: "Ukraine", value: "Ukraine" },
    { name: "Turquie", value: "Turkey" },
    { name: "Roumanie", value: "Romania" },
    { name: "Angleterre", value: "United Kingdom" }
  ];

  cities = [
    { name: "Paris" },
    { name: "Lyon" },
    { name: "Marseille" },
    { name: "Bordeaux" },
    { name: "Nancy"},
    { name: "Rennes"},
    { name: "Lille"}
  ]

  valiationMailForm = new UntypedFormGroup({
    idvalidationMail: new UntypedFormControl(''),
    rTname: new UntypedFormControl('', [Validators.required]),
    rTmail: new UntypedFormControl('', [Validators.required]),
    location: new UntypedFormControl('', [Validators.required]),
    city : new UntypedFormControl('')
  })

  isFrench:boolean = false;

  constructor(private apiService: IxellAPIService, private headerService: HeaderService) { }

  ngOnInit() {
    Utils.deleteStorageData();
    this.allRTmailSub = this.apiService.selectAllRtMail().subscribe(data => {
      if(data){
        data.forEach(element =>{
          this.allMails.push(Validationmail.parseToValidationmail(element));
        })
      }
      if (this.allRTmailSub != null) this.allRTmailSub.unsubscribe();
    }, error => {
      if(this.allRTmailSub != null) this.allRTmailSub.unsubscribe();
      console.log(error);
    })
    this.headerService.changeTitle("IxellWebLab");
    this.headerService.changeLogo(null);
  }

  ngOnDestroy(){
    if(this.allRTmailSub != null) this.allRTmailSub.unsubscribe();
    if(this.modifyRtSub != null) this.modifyRtSub.unsubscribe();
    if(this.deleteRtSub != null) this.deleteRtSub.unsubscribe();
    if(this.addRtSub != null) this.addRtSub.unsubscribe();
  }

  selectedCountry(){
    if (this.valiationMailForm.value.location.ToLower() == "france"){
      this.isFrench = true;
    } else {
      this.isFrench = false;
    }
  }

  displayModifyModal(id: number){
    this.actualId = id;
    let modal = document.getElementById("modifyModal");
    modal.style.display = "block";
    let index = this.allMails.findIndex(el => el.idvalidationMail == id);
    this.actualMail = this.allMails[index].rTmail;
    this.actualName = this.allMails[index].rTname;
    this.actualLocation = this.allMails[index].location;

    if(this.allMails[index].city != null){
      this.isFrench = true;
      this.actualCity = this.allMails[index].city;
    } else {
      this.isFrench = false;
    }
    
    this.valiationMailForm.setValue({
      idvalidationMail: this.actualId,
      rTname: this.actualName,
      rTmail: this.actualMail,
      location: this.actualLocation,
      city: this.actualCity
    })
    
  }

  closeModifyModal(){
    // Ferme la modal
    let modal = document.getElementById("modifyModal");
    modal.style.display = "none";
    this.isFrench = false;
  }

  displayDeleteModal(id: number){
    this.errorForm = false;
    let modal = document.getElementById("deleteModal");
    modal.style.display = "block";
    let index = this.allMails.findIndex(el => el.idvalidationMail == id);
    this.actualMail = this.allMails[index].rTmail;
    this.actualName = this.allMails[index].rTname;
    this.actualLocation = this.allMails[index].location;
    this.actualId = id;
  }

  displayAddModal(){
    this.errorForm = false;
    let modal = document.getElementById("addModal");
    modal.style.display = "block";
    this.valiationMailForm.reset();
  }

  closeAddModal(){
    // Ferme la modal
    let modal = document.getElementById("addModal");
    modal.style.display = "none";
    this.isFrench = false;
  }
  
  closeDeleteModal(){
    // Ferme la modal
    let modal = document.getElementById("deleteModal");
    modal.style.display = "none";
  }

  deleteRt(){
    this.deleteRtSub = this.apiService.deleteRtMail(this.actualId).subscribe(data => {
      if(data == true){
        let index = this.allMails.findIndex(el => el.idvalidationMail == this.actualId);
        this.allMails.splice(index, index);
        this.closeDeleteModal();
      } else {
        // Gestion d'erreurs à faire
      }
      if (this.deleteRtSub != null) this.deleteRtSub.unsubscribe();
    }, error => {
      if(this.deleteRtSub != null) this.deleteRtSub.unsubscribe();
      console.log(error);
    })
  }

  modifyRT(){
    if(this.valiationMailForm.status == "VALID"){
      this.errorForm = false;
      let dataToSend = this.valiationMailForm.value;
      this.modifyRtSub = this.apiService.modifyRt(dataToSend).subscribe(data => {
        if(data == true){
          let index = this.allMails.findIndex(el => el.idvalidationMail == this.actualId);
          this.allMails[index].location = this.valiationMailForm.value.location;
          this.allMails[index].rTmail = this.valiationMailForm.value.rTmail;
          this.allMails[index].rTname = this.valiationMailForm.value.rTname;
          this.allMails[index].city = this.valiationMailForm.value.city;
          this.isFrench = false;
          this.closeModifyModal();
        } else {
          // Gestion d'erreurs à faire
        }
        if (this.modifyRtSub != null) this.modifyRtSub.unsubscribe();
      }, error => {
        if(this.modifyRtSub != null) this.modifyRtSub.unsubscribe();
        console.log(error);
      })
    } else {
      this.errorForm = true;
    }
  }

  addRT(){
    this.valiationMailForm.value.idvalidationMail = 0;
    if(this.valiationMailForm.status == "VALID"){
      this.errorForm = false;
      let dataToSend = this.valiationMailForm.value;
      this.addRtSub = this.apiService.addRt(dataToSend).subscribe(data => {
        if(data > 0){
          let objdata = { 
            idvalidationMail : data ,
            location : this.valiationMailForm.value.location ,
            rTmail : this.valiationMailForm.value.rTmail,
            rTname : this.valiationMailForm.value.rTmail , 
            city : this.valiationMailForm.value.city
          }
          this.allMails.push(objdata);
          this.closeAddModal();
          this.isFrench = false;
        }
        if (this.addRtSub != null) this.addRtSub.unsubscribe();
      }, error => {
        if(this.addRtSub != null) this.addRtSub.unsubscribe();
        console.log(error);
      })
    } else {
      this.errorForm = true;
    }
  }

}
